<template>
  <div class="company-info-form">
    <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
      <div class="dialog-add-account__form-item">
        <div
          class="form-input"
          :class="[
            { 'form-input--full': value.legal_name },
            {
              'form-input--error': errors.legal_name || (serverErrors && serverErrors.legal_name),
            },
          ]"
        >
          <input
            :value="value.legal_name"
            type="text"
            required
            :disabled="disabled"
            @input="$emit('update:legal_name', $event.target.value)"
          />
          <span class="form-input__label">
            {{ $t('business_account_data.entity_name') }}
          </span>
          <div v-if="errors.legal_name" class="form-input__error" v-text="errors.legal_name" />
          <div v-if="serverErrors && serverErrors.legal_name" class="form-input__error">
            <p v-for="(err, index) in serverErrors.legal_name" :key="index">
              {{ err }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="dialog-add-account__form-col dialog-add-account__form-col--big">
      <div class="dialog-add-account__form-item">
        <div
          class="form-input"
          :class="[
            { 'form-input--full': value.legal_address },
            {
              'form-input--error':
                errors.legal_address || (serverErrors && serverErrors.legal_address),
            },
          ]"
        >
          <input
            :value="value.legal_address"
            type="text"
            required
            :disabled="disabled || isLegalAddressDisabled"
            @input="$emit('update:legal_address', $event.target.value)"
          />
          <span class="form-input__label">
            {{ $t('business_account_data.legal_address') }}
          </span>
          <div
            v-if="errors.legal_address"
            class="form-input__error"
            v-text="errors.legal_address"
          />
          <div v-if="serverErrors && serverErrors.legal_address" class="form-input__error">
            <p v-for="(err, index) in serverErrors.legal_address" :key="index">
              {{ err }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-add-account__inline-row">
      <div class="dialog-add-account__form-col">
        <div class="dialog-add-account__form-item">
          <div
            class="form-input"
            :class="[
              {
                'form-input--full': value.legal_receiving_physical_address,
              },
              {
                'form-input--error':
                  errors.legal_receiving_physical_address ||
                  (serverErrors && serverErrors.legal_receiving_physical_address),
              },
            ]"
          >
            <input
              :value="value.legal_receiving_physical_address"
              :disabled="disabled || isPostAddressDisabled"
              type="text"
              required
              @input="$emit('update:legal_receiving_physical_address', $event.target.value)"
            />
            <span class="form-input__label">{{ $t('business_account_data.post_address') }}</span>
            <div
              v-if="errors.legal_receiving_physical_address"
              class="form-input__error"
              v-text="errors.legal_receiving_physical_address"
            />
            <div
              v-if="serverErrors && serverErrors.legal_receiving_physical_address"
              class="form-input__error"
            >
              <p v-for="(err, index) in serverErrors.legal_receiving_physical_address" :key="index">
                {{ err }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="dialog-add-account__form-col">
        <div class="dialog-add-account__form-item">
          <div class="dialog-add-account__form-correspond">
            <label class="input__item-checkbox">
              <input
                type="checkbox"
                :checked="value.toggleAddress"
                :disabled="false"
                @change="handleToggleAddress"
              />
              <span class="input__item-checkbox__check">
                <img src="@/assets/icons/icon-done.svg" />
              </span>
              <span class="input__item-checkbox__info">
                <span class="input__item-checkbox__title">
                  {{ $t('business_account_data.corresponding_legal') }}
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyInfoForm',
  props: {
    value: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          'legal_name' in value &&
          'legal_address' in value &&
          'legal_receiving_physical_address' in value &&
          'toggleAddress' in value
        );
      },
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    serverErrors: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isLegalAddressDisabled: {
      type: Boolean,
      default: false,
    },
    isPostAddressDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleToggleAddress(event) {
      const checked = event.target.checked;
      this.$emit('update:toggleAddress', checked);
      this.$emit('toggle-address-change', checked);
    },
  },
  emits: [
    'update:legal_name',
    'update:legal_address',
    'update:legal_receiving_physical_address',
    'update:toggleAddress',
    'toggle-address-change',
  ],
};
</script>

<style lang="scss" scoped>
.dialog-add-account {
  &__inline-row {
    display: flex;
    width: 100%;
  }
}
.company-info-form {
  display: flex;
  flex-direction: column;
  width: 100%;
}
</style>
